import { TRADE_AI_ANALYSIS_PATH } from '../../constants'
import AbstractService from '../../services/AbstractService'
import { ServerResponse } from '../../types'

import { TradeAiAnalysis, TradeAiAnalysisRequestParams } from './types'

class TradeAiAnalysisServiceClass extends AbstractService {
  analyze = (tradeId: number, params?: TradeAiAnalysisRequestParams) =>
    this.request<ServerResponse<TradeAiAnalysis>>(
      `${TRADE_AI_ANALYSIS_PATH}/${tradeId}`,
      'post',
      false,
      null,
      {
        params,
      },
    )
}

export const TradeAiAnalysisService = new TradeAiAnalysisServiceClass()
